import classnames from 'classnames';
import { ReactNode } from 'react';

import { TextLink } from '../TextLink';
import './DrawerLink.css';

export interface DrawerLinkProps {
  /** Callback when the link is clicked */
  onClick: () => void;
  /** Custom link text */
  text?: string;
  /** Icon to display after the text */
  icon?: ReactNode;
  /** Additional CSS class name if needed */
  className?: string;
  /** Test ID for automated testing */
  'data-testid'?: string;
}

/**
 * DrawerLink component
 *
 * A generic link component that can be used to trigger drawer opening.
 * Displays custom text with an optional icon.
 *
 * @example
 * <DrawerLink onClick={() => setIsDrawerOpen(true)} text="Open Drawer" />
 * <DrawerLink onClick={handleClick} text="Help" icon={<InfoIcon />} />
 */
export function DrawerLink({ onClick, text = '', icon, className = '', 'data-testid': dataTestId }: DrawerLinkProps) {
  return (
    <TextLink
      className={classnames('drawer-link', className)}
      data-testid={dataTestId ?? 'drawer-link'}
      icon={icon}
      text={text}
      onClick={onClick}
    />
  );
}
